<template>
  <div v-if="isPC" class="custom-nav">
    <div v-for="n in navigateList" :key="n.id" class="item" :class="{pointer: n.linkUrl||n.child }" @click="clickNav(n)">
      <div v-if="!n.child || !n.child.length">
        <img v-if="n.imgUrl" :src="n.imgUrl" style="height:28px" alt="" />
        <div v-else class="title">{{ n.name }}</div>
        <img v-if="n.labelImgUrl" :src="n.labelImgUrl" class="hot" alt="" />
      </div>
      <el-popover
        v-else
        placement="bottom-start"
        min-width="200"
        trigger="hover"
        popper-class="nav-popover">
        <el-cascader-panel :options="n.child" :props="{ value: 'id', children: 'child', expandTrigger: 'hover', checkStrictly: false }">
          <template slot-scope="{ data }">
            <div @click="clickNav(data)" class="f--c nav-popover-item" :style="{cursor: data.linkUrl ? 'pointer' : 'default' }">
              <img v-if="data.imgUrl" :src="data.imgUrl" style="height:28px" alt="" />
              <div v-else class="title">{{ data.name }}</div>
              <img v-if="data.labelImgUrl" :src="data.labelImgUrl" class="hot" alt="" />
            </div>
          </template>
        </el-cascader-panel>
        <template slot="reference">
          <img v-if="n.imgUrl" :src="n.imgUrl" style="height:28px" alt="" />
          <div v-else class="title">{{ n.name }}</div>
          <img v-if="n.labelImgUrl" :src="n.labelImgUrl" class="hot" alt="" />
        </template>
      </el-popover>
    </div>
  </div>
  <div v-else class="mobile-custom-nav">
    <div v-for="n in navigateList" :key="n.id" class="item">
      <div v-if="!n.child || !n.child.length" class="item-stair" @click="clickNav(n)">
        <img v-if="n.imgUrl" :src="n.imgUrl" class="title-img" alt="" />
        <div v-else class="title">{{ n.name }}</div>
        <img v-if="n.labelImgUrl" :src="n.labelImgUrl" class="hot" alt="" />
      </div>
      <div v-else class="multistep-nav">
        <van-collapse v-model="showMultistepNav" :border="false">
          <van-collapse-item :name="n.id">
            <template #title>
              <div class="item-stair" @click="clickNav(n)">
                <img v-if="n.imgUrl" :src="n.imgUrl" class="title-img" alt="" />
                <div v-else class="title">{{ n.name }}</div>
                <img v-if="n.labelImgUrl" :src="n.labelImgUrl" class="hot" alt="" />
              </div>
            </template>
            <div v-for="c in n.child" :key="c.id" class="f-b-c">
              <div class="item-stair" @click="clickNav(c)">
                <img v-if="c.imgUrl" :src="c.imgUrl" class="title-img" alt="" />
                <div v-else class="title">{{ c.name }}</div>
                <img v-if="c.labelImgUrl" :src="c.labelImgUrl" class="hot" alt="" />
              </div>
              <i v-if="c.child && c.child.length" class="iconfont icon-Frame_2" style="font-size:17px" @click="handleThreeNav(c)"></i>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <van-popup v-model="showThreeNav" position="left" :style="{ width: '100%',height: '100%' }" closeable close-icon-position="top-left">
      <div class="navigationContent">
        <div>
          <div class="f--c top" @click="showThreeNav = false">
            <i class="iconfont icon-dajiantouzuo"></i>
            <div class="top-title" style="margin-left:10px">
              <img v-if="secondNavData.imgUrl" :src="secondNavData.imgUrl" alt="" />
              <div v-else class="title">{{ secondNavData.name }}</div>
            </div>
          </div>
          <div v-for="n in secondNavData.child" :key="n.id" class="item">
            <div v-if="!n.child || !n.child.length" class="item-stair" @click="clickNav(n)">
              <img v-if="n.imgUrl" :src="n.imgUrl" class="title-img" alt="" />
              <div v-else class="title">{{ n.name }}</div>
              <img v-if="n.labelImgUrl" :src="n.labelImgUrl" class="hot" alt="" />
            </div>
            <div v-else class="multistep-nav">
              <van-collapse v-model="showMultistepNav" :border="false">
                <van-collapse-item :name="n.id">
                  <template #title>
                    <div class="item-stair" @click="clickNav(n)">
                      <img v-if="n.imgUrl" :src="n.imgUrl" class="title-img" alt="" />
                      <div v-else class="title">{{ n.name }}</div>
                      <img v-if="n.labelImgUrl" :src="n.labelImgUrl" class="hot" alt="" />
                    </div>
                  </template>
                  <div v-for="c in n.child" :key="c.id" class="f-b-c">
                    <div class="item-stair" @click="clickNav(c)">
                      <img v-if="c.imgUrl" :src="c.imgUrl" class="title-img" alt="" />
                      <div v-else class="title">{{ c.name }}</div>
                      <img v-if="c.labelImgUrl" :src="c.labelImgUrl" class="hot" alt="" />
                    </div>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import Collapse from 'vant/lib/collapse'
import 'vant/lib/collapse/style'
import CollapseItem from 'vant/lib/collapse-item'
import 'vant/lib/collapse-item/style'

export default {
  components: {
    'van-popup': popup,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem
  },
  data() {
    return {
      navigateList: [], // 导航列表
      showMultistepNav: [], // 移动端 一二级折叠板
      showThreeNav: false, // 移动端 三级弹出框
      secondNavData: {} // 移动端 二级数据
    }
  },
  created() {
    this.getNavigateList()
  },
  methods: {
    getNavigateList() {
      this.$store.dispatch('common/customNavList').then(data => {
        this.deletechildList(data)
        this.navigateList = data
      })
    },
    deletechildList(arr) {
      arr.forEach((item) => {
        if (item.child && !item.child.length) {
          delete item.child
        } else {
          this.deletechildList(item.child)
        }
      })
    },

    // 导航跳转
    clickNav(item) {
      if (item.status === 0 || !item.linkUrl) return
      if (item.menuType === 1 || item.menuType === 4) {
        location.href = item.linkUrl
      } else {
        this.$router.push(item.linkUrl)
        this.getNavigateList()
      }
    },

    handleThreeNav(item) {
      this.showThreeNav = true
      this.secondNavData = item
    }
  }
}

</script>

<style lang="scss" scoped>
.custom-nav{
  display: flex;
  padding-top: 12px;
  .item {
    display: flex;
    align-items: center;
    height: 30px;
    padding: 0 12px;
    position: relative;
    border-radius: 4px;
    &:hover {
      background-color: #efefef;
    }
    .hot {
      width: 28px;
      height: 16px;
      position: absolute;
      top: -3px;
      right: -10px;
      z-index: 1;
    }
  }
}
.nav-popover {
  .el-cascader-panel {
    border: none !important;
    /deep/ .el-cascader-node{
      padding: 0 !important;
      padding-left: 10px !important;

      .el-icon-check::before{
        content: ''
      }
    }
    /deep/ li.el-cascader-node {
      display: flex;
      align-items: center;
      .el-cascader-node__label {
        padding-left: 0px;
      }
      i {
        position: unset;
        padding-right: 10px;
      }
    }
  }
  .nav-popover-item{
    .hot {
      width: 28px;
      height: 16px;
      top: -5px;
      position: relative;
    }
  }
}

// 移动端
.mobile-custom-nav {
  .item {
    padding: .1rem .3rem;
    border-bottom: 2px solid transparent;
    .item-stair {
      display: inline-flex;
      max-width: 3.24rem;
    }
    .multistep-nav {

      /deep/ .van-collapse-item__title{
        padding: 0;
        &::after{
          content:'';
          border: 0;
        }
      }
    }
    .title-img{
      height: .46rem;
      display: inline-block;
      font-size: 0;
    }
    .hot{
      height: .2rem;
      display: inline-block;
    }
  }
  .navigationContent{
    padding: 1.2rem 0 1.5rem .3rem;
    position: relative;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    >div {
      overflow-y: auto;
    }
    .top {
      color: #000;
      margin-bottom: .2rem;
      font-size: .32rem;
      display: flex;
      .top-title{
        height: .46rem;

        img {
          height: 100%;
        }
      }
    }
  }
}
</style>
<style>
.el-popover.nav-popover{
  padding: 0;
}
</style>
